import React from 'react';
import { bool, shape, string } from 'prop-types';

const ApplicationType = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5001 12H13.5001L14.8772 15.6467C15.1242 16.3008 14.6408 17 13.9417 17H10.0595C9.36044 17 8.87711 16.301 9.12391 15.647L10.5001 12ZM11.5001 14L11.0001 15H13.0001L12.5001 14H11.5001Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M11.0001 23L11.0001 19H13.0001L13.0001 23H11.0001Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.8321 21.0508L14.168 18.5547L15.8321 17.4453L17.4962 19.9414L15.8321 21.0508Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M6.50394 19.9415L8.16804 17.4453L9.83214 18.5547L8.16804 21.0509L6.50394 19.9415Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.1894 3.58212C4.71562 2.92036 5.18863 2 6.0025 2H17.9974C18.8112 2 19.2842 2.92034 18.8105 3.5821L13.5001 11H10.5001L5.1894 3.58212ZM7.94309 4L11.5145 9H12.4853L16.0567 4H7.94309Z" fill="currentColor" />
  </svg>
);

ApplicationType.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ApplicationType;
